<template>
  <div class="loginContainer">
    <LoginHeader></LoginHeader>
    <div class="login-content outer-container">
      <form class="form-signin inner-container" @submit.prevent="updatePassword()" id="form">
        <div class="wellmetrics-event-pl">WELLMETRICS EVENT PLANNER</div>
        <br/>
        <div class="subText">Create, request and schedule biometric screening events with ADURO</div>
        <div class="formInput">
          <div>
            <div class="form-title">
              Enter your new password to reset.
            </div>
            <div class="row inputText">
              <div class="labelText">
                <label>New password</label>
              </div>
              <div class="input-wrapper">
                <label>
                  <input type="password" data-vv-as="new password" name="newPassword" v-model="newPassword" class="form-control" v-validate="'required'" @blur="validateInput('newPassword')">
                </label>
                <div class="errorBackground" :class="{errorBackgroundColor : errors.has('newPassword') && validatedFields.includes('newPassword') || !isPasswordContainsNumber}">
                  <span v-if="validatedFields.includes('newPassword')" class="errorDetail" v-show="errors.first('newPassword')">{{ errors.first('newPassword') }}</span>
                  <span v-if="!isPasswordContainsNumber && !errors.has('newPassword')" class="errorDetail">The New password must contains at least 1 digit</span>
                </div>
              </div>
            </div>
            <div class="row inputText">
              <div class="labelText">
                <label>New password again</label>
              </div>
              <div class="input-wrapper">
                <label>
                  <input type="password" data-vv-as="password" name="repeatPassword" v-model="reNewPassword" class="form-control" v-validate="{ required: true, confirmed: newPassword }" @blur="validateInput('repeatPassword')">
                </label>
                <div class="errorBackground" :class="{errorBackgroundColor : errors.has('repeatPassword') && validatedFields.includes('repeatPassword')}">
                  <span v-if="validatedFields.includes('repeatPassword')" class="errorDetail" v-show="errors.has('repeatPassword')">{{ errors.first('repeatPassword') }}</span>
                </div>
              </div>
            </div>
            <div class="password-check-list">
              <div class="password-at-least">Password must have at least:</div>
              <div class="indicators-password row">
                <div class="indicator-item col-lg-6">
                  <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
                    <div class="icon-reach" v-if="passwordCheckList.length"></div>
                    <div class="icon-unreach" v-else></div>
                  </div>
                  <div class="text">8 characters </div>
                </div>
                <div class="indicator-item col-lg-6">
                  <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
                    <div class="icon-reach" v-if="passwordCheckList.lowerCaseChars"></div>
                    <div class="icon-unreach" v-else></div>
                  </div>
                  <div class="text">4 lowercase letters (a-z)</div>
                </div>
                <div class="indicator-item col-lg-6">
                  <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
                    <div class="icon-reach" v-if="passwordCheckList.upperCaseChars"></div>
                    <div class="icon-unreach" v-else></div>
                  </div>
                  <div class="text">1 uppercase letter (A-Z)</div>
                </div>
                <div class="indicator-item col-lg-6">
                  <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
                    <div class="icon-reach" v-if="passwordCheckList.numbers"></div>
                    <div class="icon-unreach" v-else></div>
                  </div>
                  <div class="text">2 numbers (0-9)</div>
                </div>
                <div class="indicator-item col-lg-6">
                  <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
                    <div class="icon-reach" v-if="passwordCheckList.specialChars"></div>
                    <div class="icon-unreach" v-else></div>
                  </div>
                  <div class="text">1 special character</div>
                </div>
              </div>
            </div>
            <div class="row footerForm">
              <div class="col-md-9 forgotPassword">
              </div>
              <div class="col-md-3">
                <button class="btn btn-reset-password" type="submit" :disabled="isDisabled">Update password</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div> <!-- /container -->
</template>

<script>
  import Vue from 'vue';
  import LoginHeader from './login/LoginHeader';
  import {mapGetters, mapActions} from 'vuex';
  import constants from '../../_consts';
  import VeeValidate from 'vee-validate';
  import validator from '@/utils/validator';

  Vue.use(VeeValidate);

  export default {
    name: 'updatePassword',
    components: {
      LoginHeader
    },
    data () {
      return {
        newPassword: null,
        reNewPassword: null,
        submitData: null,
        validatedFields: [],
        isPasswordContainsNumber: true,
        isDisabled: true,
        passwordCheckList: {
          length: false,
          lowerCaseChars: false,
          upperCaseChars: false,
          numbers: false,
          specialChars: false
        }
      };
    },
    computed: {
      token: function () {
        return this.$route.params.token;
      },
      ...mapGetters({
        getValidToken: 'GETTERS_GET_VALID_TOKEN',
        getLoginEmail: 'GETTERS_GET_LOGIN_EMAIL'
      })
    },
    methods: {
      validateInput (field) {
        if (!this.validatedFields.includes(field)) {
          this.validatedFields.push(field);
        }
        let atLeastNumber = new RegExp(/\d/);
        this.$validator.validate().then(result => {
          if (this.validatedFields.includes('newPassword')) {
            this.isPasswordContainsNumber = atLeastNumber.test(this.newPassword);
          } else {
            this.isPasswordContainsNumber = true;
          }

          let pwRuleValidate = validator.isPasswordValid(this.newPassword);
          this.passwordCheckList = pwRuleValidate.detail;

          if (result && pwRuleValidate.summary) {
            this.isDisabled = !atLeastNumber.test(this.reNewPassword);
          } else {
            this.isDisabled = true;
          }
        });
      },
      updatePassword: function () {
        if (this.newPassword !== this.reNewPassword) {
          this.$toastr('error', 'New password is NOT matched!', '');
        } else {
          let isForceResetPassword = localStorage.getItem(constants.LOCAL_STORE.isForceResetPassword) || false;
          let userId = localStorage.getItem(constants.LOCAL_STORE.userId);
          this.doUpdatePassword({newPassword: this.newPassword, token: this.token, isForceResetPassword: isForceResetPassword, userId: userId}).then(() => {
            if (this.getValidToken) {
              // login
              this.doLogin({username: this.getLoginEmail, password: this.newPassword}).then(() => {
                this.$router.push('/login');
              });
            }
          });
        }
      },
      ...mapActions({
        doUpdatePassword: 'ACTION_UPDATE_PASSWORD',
        checkToken: 'ACTION_CHECK_TOKEN',
        doLogin: 'ACTION_DO_LOGIN'
      })
    },
    mounted () {
      let isForceResetPassword = localStorage.getItem(constants.LOCAL_STORE.isForceResetPassword) === 'true';
      if (this.token !== 'force-reset-password') {
        this.checkToken(this.token).then(() => {
          if (!this.getValidToken && !isForceResetPassword) {
            this.$router.push('/login');
          }
        });
      }
    },
    watch: {
      'newPassword': {
        handler: function () {
          this.passwordCheckList = validator.isPasswordValid(this.newPassword).detail;
        }
      }
    }
  };
</script>


<style lang="less" scoped>
  @import '../../styles/variables.less';

  .loginContainer {
    height: 100vh;
    background-color: @blue;

    .login-content {
      position: absolute;
      top: 25%;
    }
    .wellmetrics-event-pl {
      height: 29px;
      color: @white;
      font-family: @font-family-title;
      font-size: 27px;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }

    .labelText {
      margin-top: 10px;
      width: 30%;
    }
    .subText {
      font-family: @font-family-title;
      font-size: 14px;
      color: @white;
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }

    .formInput {
      background-color: @white;
      width: 575px;
      border-radius: 5px;
      padding: 55px 50px 35px 50px;
      margin: auto;
      .form-title {
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: bold;
        padding: 0;
      }
    }

    .inputText {
      margin: 15px 0 0 0;
      .input-wrapper {
        width: 70%;
        label {
          width: 100%;
        }
      }
    }

    .submitButton {
      float: right;
      margin-top: 15px;
      background-color: @blue;
      color: @white;
    }

    .btn-reset-password {
      float: right;
      margin-top: 15px;
      background-color: @blue;
      color: @white;
      padding: 7px 25px 10px 25px;
    }

    .forgotPassword {
      margin-top: 20px;
    }

    .loginContainer {
      height: 100%;
    }

    .form-signin {
      padding: 15px;
      margin: 0 auto;
    }

    .footerForm {
      margin-top: 0;
    }

    .form-signin .form-signin-heading,
    .form-signin .checkbox {
      margin-bottom: 10px;
      text-align: center;
      margin-top: 20px;
    }
    .form-signin .checkbox {
      font-weight: normal;
    }
    .form-signin .form-control {
      position: relative;
      height: auto;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 16px;
      border-radius: 5px;
      background-color: @white;
    }
    .form-signin .form-control:focus {
      z-index: 2;
    }
    .errorBackground {
      width: auto;
      height: 21px;
      margin-top: 1px;
    }
    .errorDetail {
      height: 17px;
      width: 108px;
      color: #803939;
      font-family: "Open Sans",serif;
      font-size: 12px;
      line-height: 17px;
      text-align: right;
      margin-left: 5px;
    }
    .errorBackgroundColor {
      background-color: #FEE2E2;
    }
  }
</style>



// WEBPACK FOOTER //
// UpdatePassword.vue?a084c138